/* eslint-disable */
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Instant: { input: string; output: string };
};

export type BuyerInventoryConfiguration = {
  __typename?: 'BuyerInventoryConfiguration';
  id: Scalars['ID']['output'];
  location: Location;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  targetWeeksCovered: Scalars['Float']['output'];
  usageRatePerWeek: Quantity;
  weeksCoveredBeforeMonitor: Scalars['Float']['output'];
  weeksCoveredBeforeUrgent: Scalars['Float']['output'];
};

export type Cart = {
  __typename?: 'Cart';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<OrderItem>>;
  sellingOrganization: Organization;
  shippingLocation?: Maybe<Location>;
};

export type CartFilterInput = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
};

export type Company = {
  __typename?: 'Company';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<Location>>;
  name: Scalars['String']['output'];
  organization: Organization;
  user: User;
};

export type EnumOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
};

export type IdOperatorInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  buyerInventoryConfiguration?: Maybe<BuyerInventoryConfiguration>;
  id: Scalars['ID']['output'];
  inboundStock: Scalars['Float']['output'];
  location: Location;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
};

export type Length = {
  __typename?: 'Length';
  actualLengthInches: Scalars['Float']['output'];
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nominalLengthInches?: Maybe<Scalars['Float']['output']>;
};

export type LengthWithStock = {
  __typename?: 'LengthWithStock';
  length: Length;
  stockInPieces: Scalars['Float']['output'];
};

export type Location = {
  __typename?: 'Location';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company: Company;
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization: Organization;
  region: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type LumberGrade = {
  __typename?: 'LumberGrade';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LumberSpecies = {
  __typename?: 'LumberSpecies';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  confirmOrder?: Maybe<Order>;
  placeOrder?: Maybe<Order>;
  receiveOrder?: Maybe<Order>;
  shipOrder?: Maybe<Order>;
  updateCart?: Maybe<Cart>;
  updatePurchaseOrderNumber?: Maybe<Order>;
  upsertBuyerInventoryConfiguration?: Maybe<BuyerInventoryConfiguration>;
  upsertInventory?: Maybe<Inventory>;
  upsertSellerInventory?: Maybe<Inventory>;
  upsertSellerProductConfiguration?: Maybe<SellerProductConfiguration>;
};

export type MutationConfirmOrderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPlaceOrderArgs = {
  locationId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};

export type MutationReceiveOrderArgs = {
  id: Scalars['ID']['input'];
};

export type MutationShipOrderArgs = {
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
  deliveryStartDate: Scalars['Instant']['input'];
  id: Scalars['ID']['input'];
  shippedDate: Scalars['Instant']['input'];
};

export type MutationUpdateCartArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
  quantity: QuantityInput;
  sellingOrganizationId: Scalars['ID']['input'];
};

export type MutationUpdatePurchaseOrderNumberArgs = {
  id: Scalars['ID']['input'];
  purchaseOrderNumber: Scalars['String']['input'];
};

export type MutationUpsertBuyerInventoryConfigurationArgs = {
  locationId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  targetWeeksCovered?: InputMaybe<Scalars['Float']['input']>;
  usageRatePerWeek: QuantityInput;
  weeksCoveredBeforeMonitor?: InputMaybe<Scalars['Float']['input']>;
  weeksCoveredBeforeUrgent?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpsertInventoryArgs = {
  locationId: Scalars['ID']['input'];
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type MutationUpsertSellerInventoryArgs = {
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
};

export type MutationUpsertSellerProductConfigurationArgs = {
  platformProductLengthId: Scalars['ID']['input'];
  sellerProductConfigurationInput: SellerProductConfigurationInput;
};

export type NumberOperatorInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

export type Order = {
  __typename?: 'Order';
  buyer: User;
  buyingOrganization: Organization;
  createdAt: Scalars['Instant']['output'];
  deliveryEndDate?: Maybe<Scalars['Instant']['output']>;
  deliveryStartDate?: Maybe<Scalars['Instant']['output']>;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['Instant']['output']>;
  sellingOrganization: Organization;
  shippedDate?: Maybe<Scalars['Instant']['output']>;
  shippingLocation: Location;
  status: Scalars['String']['output'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  platformProductsLengths: PlatformProductLength;
  price: Scalars['Float']['output'];
  quantity: Quantity;
};

export type OrderStatus =
  | 'CONFIRMED'
  | 'DELIVERED'
  | 'DRAFT'
  | 'PENDING_SELLER_CONFIRMATION'
  | 'SHIPPED';

export type OrderStatusCount = {
  __typename?: 'OrderStatusCount';
  confirmed: Scalars['Int']['output'];
  delivered: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  pendingSellerConfirmation: Scalars['Int']['output'];
  shipped: Scalars['Int']['output'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PageInput = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type PagedInventory = {
  __typename?: 'PagedInventory';
  content: Array<Maybe<Inventory>>;
  paging: Paging;
};

export type PagedSellerProductConfiguration = {
  __typename?: 'PagedSellerProductConfiguration';
  content: Array<Maybe<SellerProductConfiguration>>;
  paging: Paging;
};

export type PagedUniqueProductWithSellers = {
  __typename?: 'PagedUniqueProductWithSellers';
  content: Array<Maybe<UniqueProductWithSellers>>;
  paging: Paging;
};

export type PaginatedSellerProductInventory = {
  __typename?: 'PaginatedSellerProductInventory';
  content: Array<Maybe<SellerProductInventory>>;
  paging: Paging;
};

export type Paging = {
  __typename?: 'Paging';
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PlatformProduct = {
  __typename?: 'PlatformProduct';
  actualLengthInches?: Maybe<Scalars['Float']['output']>;
  actualThicknessInches?: Maybe<Scalars['Float']['output']>;
  actualWidthInches?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  constructionCode?: Maybe<Scalars['String']['output']>;
  finishCode?: Maybe<Scalars['String']['output']>;
  harmonizedCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isNominal?: Maybe<Scalars['Boolean']['output']>;
  lengths?: Maybe<Array<Maybe<Length>>>;
  materialCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nominalThicknessInches?: Maybe<Scalars['Float']['output']>;
  nominalWidthInches?: Maybe<Scalars['Float']['output']>;
  piecesPerBundle: Quantity;
  properties?: Maybe<ProductProperties>;
  standardUnitsCode?: Maybe<UnitCode>;
  unitsPerContainer: Quantity;
  unitsPerRailCar: Quantity;
  unitsPerTruckload: Quantity;
};

export type PlatformProductLength = {
  __typename?: 'PlatformProductLength';
  id: Scalars['ID']['output'];
  latestPriceMax?: Maybe<Scalars['Float']['output']>;
  latestPriceMid?: Maybe<Scalars['Float']['output']>;
  latestPriceMin?: Maybe<Scalars['Float']['output']>;
  length: Length;
  platformProduct: PlatformProduct;
};

export type ProductDimension = {
  __typename?: 'ProductDimension';
  nominalThicknessInches?: Maybe<Scalars['Float']['output']>;
  nominalWidthInches?: Maybe<Scalars['Float']['output']>;
};

export type ProductFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ProductProperties = {
  __typename?: 'ProductProperties';
  construction?: Maybe<ProductProperty>;
  dryness?: Maybe<ProductProperty>;
  grade?: Maybe<ProductProperty>;
  species?: Maybe<ProductProperty>;
  surfacing?: Maybe<ProductProperty>;
  treatment?: Maybe<ProductProperty>;
};

export type ProductProperty = {
  __typename?: 'ProductProperty';
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Quantity = {
  __typename?: 'Quantity';
  unit: UnitCode;
  value: Scalars['Float']['output'];
};

export type QuantityInput = {
  unit: UnitCode;
  value: Scalars['Float']['input'];
};

export type Query = {
  __typename?: 'Query';
  allUniqueProductInventoryLocationsForBuyer: Array<Location>;
  availableProducts: PagedSellerProductConfiguration;
  buyerInventory: PagedInventory;
  buyerInventoryForLocation: PagedInventory;
  buyerProductInventory: Inventory;
  cart?: Maybe<Cart>;
  carts?: Maybe<Array<Cart>>;
  currentUser: User;
  findAvailableUniqueProductsWithSellers: PagedUniqueProductWithSellers;
  lengths?: Maybe<Array<Length>>;
  locations?: Maybe<Array<Location>>;
  lumberGrades: Array<LumberGrade>;
  lumberSpecies: Array<LumberSpecies>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Order>>;
  ordersCount: OrderStatusCount;
  platformProduct?: Maybe<PlatformProduct>;
  platformProductDimensions: Array<ProductDimension>;
  platformProducts?: Maybe<Array<PlatformProduct>>;
  platformProductsLengthsForProduct?: Maybe<Array<PlatformProductLength>>;
  sellerInventoryProductLengthsByPlatformProduct?: Maybe<
    Array<PlatformProductLength>
  >;
  sellerProduct?: Maybe<SellerProductConfiguration>;
  sellerProductInventories: PaginatedSellerProductInventory;
  sellerProductInventoriesForBuyer?: Maybe<
    Array<Maybe<SellerProductInventory>>
  >;
  sellerProductInventory?: Maybe<SellerProductInventory>;
  users?: Maybe<Array<User>>;
};

export type QueryAvailableProductsArgs = {
  pageInput: PageInput;
};

export type QueryBuyerInventoryArgs = {
  pageInput: PageInput;
};

export type QueryBuyerInventoryForLocationArgs = {
  locationId: Scalars['ID']['input'];
  pageInput: PageInput;
};

export type QueryBuyerProductInventoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCartArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCartsArgs = {
  filter?: InputMaybe<CartFilterInput>;
};

export type QueryFindAvailableUniqueProductsWithSellersArgs = {
  filters?: InputMaybe<UniqueProductFiltersInput>;
  pageInput: PageInput;
};

export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};

export type QueryOrdersArgs = {
  status?: InputMaybe<OrderStatus>;
};

export type QueryPlatformProductArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPlatformProductsArgs = {
  filter?: InputMaybe<ProductFilterInput>;
};

export type QueryPlatformProductsLengthsForProductArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QuerySellerInventoryProductLengthsByPlatformProductArgs = {
  platformProductId: Scalars['ID']['input'];
};

export type QuerySellerProductArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySellerProductInventoriesArgs = {
  filters?: InputMaybe<SellerProductFiltersInput>;
  pageInput: PageInput;
  unitCode?: InputMaybe<UnitCode>;
};

export type QuerySellerProductInventoriesForBuyerArgs = {
  filter?: InputMaybe<SellerInventoryForBuyerFilterInput>;
};

export type QuerySellerProductInventoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
};

export type SellerInventoryForBuyerFilterInput = {
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
  platformProductLengthId?: InputMaybe<Scalars['ID']['input']>;
};

export type SellerProductConfiguration = {
  __typename?: 'SellerProductConfiguration';
  criticalStockLevel: Quantity;
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  lowStockLevel: Quantity;
  minimumOrderQuantity: Quantity;
  organization: Organization;
  platformProductLength: PlatformProductLength;
  pricePerUnit: Scalars['Float']['output'];
  readyToShipDays: Scalars['Int']['output'];
  replenishmentRatePerWeek: Quantity;
  status?: Maybe<SellerProductStatus>;
  unit: UnitCode;
};

export type SellerProductConfigurationInput = {
  criticalStockLevel?: InputMaybe<QuantityInput>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  lowStockLevel?: InputMaybe<QuantityInput>;
  minimumOrderQuantity?: InputMaybe<QuantityInput>;
  pricePerUnit?: InputMaybe<Scalars['Float']['input']>;
  readyToShipDays?: InputMaybe<Scalars['Int']['input']>;
  replenishmentRatePerWeek: QuantityInput;
  status?: InputMaybe<SellerProductStatus>;
};

export type SellerProductFiltersInput = {
  and?: InputMaybe<Array<SellerProductFiltersInput>>;
  grade?: InputMaybe<StringOperatorInput>;
  length?: InputMaybe<StringOperatorInput>;
  nominalThicknessInches?: InputMaybe<NumberOperatorInput>;
  nominalWidthInches?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<SellerProductFiltersInput>;
  or?: InputMaybe<Array<SellerProductFiltersInput>>;
  pricePerUnit?: InputMaybe<NumberOperatorInput>;
  productCode?: InputMaybe<StringOperatorInput>;
  productName?: InputMaybe<StringOperatorInput>;
  readyToShipDays?: InputMaybe<NumberOperatorInput>;
  replenishmentRatePerWeek?: InputMaybe<NumberOperatorInput>;
  species?: InputMaybe<StringOperatorInput>;
  status?: InputMaybe<EnumOperatorInput>;
  stock?: InputMaybe<NumberOperatorInput>;
  visibility?: InputMaybe<StringOperatorInput>;
};

export type SellerProductInventory = {
  __typename?: 'SellerProductInventory';
  id: Scalars['ID']['output'];
  location: Location;
  organization: Organization;
  platformProductsLength: PlatformProductLength;
  quantity: Quantity;
  sellerProductConfiguration: SellerProductConfiguration;
};

export type SellerProductStatus =
  | 'INACTIVE'
  | 'VISIBLE_TO_BUYERS'
  | 'VISIBLE_TO_MY_BUYERS';

export type StringOperatorInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notContain?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UniqueProductFiltersInput = {
  and?: InputMaybe<Array<UniqueProductFiltersInput>>;
  grade?: InputMaybe<StringOperatorInput>;
  locationId?: InputMaybe<IdOperatorInput>;
  name?: InputMaybe<StringOperatorInput>;
  nominalThicknessInches?: InputMaybe<NumberOperatorInput>;
  nominalWidthInches?: InputMaybe<NumberOperatorInput>;
  not?: InputMaybe<UniqueProductFiltersInput>;
  or?: InputMaybe<Array<UniqueProductFiltersInput>>;
  species?: InputMaybe<StringOperatorInput>;
  stockLevel?: InputMaybe<NumberOperatorInput>;
};

export type UniqueProductWithSellers = {
  __typename?: 'UniqueProductWithSellers';
  id: Scalars['ID']['output'];
  leadTimeMax: Scalars['Int']['output'];
  leadTimeMin: Scalars['Int']['output'];
  lengths?: Maybe<Array<Maybe<Length>>>;
  listingsCount: Scalars['Float']['output'];
  platformProduct: PlatformProduct;
  priceMax: Scalars['Float']['output'];
  priceMin: Scalars['Float']['output'];
  sellersCount: Scalars['Float']['output'];
  totalStock: Quantity;
};

export type Unit = {
  __typename?: 'Unit';
  category: Scalars['String']['output'];
  code: Scalars['String']['output'];
  factorToCbm: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type UnitCode = 'BF' | 'CBM' | 'LF' | 'MBF' | 'MSF' | 'PCS';

export type User = {
  __typename?: 'User';
  companies?: Maybe<Array<Company>>;
  externalId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  organization: Organization;
  role: UserRole;
};

export type UserFilterInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type UserRole = 'BUYER' | 'SELLER';

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    externalId: string;
    firstName: string;
    id: string;
    lastName: string;
    role: UserRole;
    organization: { __typename?: 'Organization'; id: string; name: string };
    companies?: Array<{
      __typename?: 'Company';
      code: string;
      id: string;
      name: string;
      organization: { __typename?: 'Organization'; id: string; name: string };
      locations?: Array<{
        __typename?: 'Location';
        addressLine1: string;
        city: string;
        country: string;
        id: string;
        name: string;
        region: string;
        zipCode: string;
      }> | null;
    }> | null;
  };
};

export type UpsertBuyerInventoryConfigurationMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  usageRatePerWeek: QuantityInput;
  weeksCoveredBeforeMonitor?: InputMaybe<Scalars['Float']['input']>;
  weeksCoveredBeforeUrgent?: InputMaybe<Scalars['Float']['input']>;
  targetWeeksCovered?: InputMaybe<Scalars['Float']['input']>;
}>;

export type UpsertBuyerInventoryConfigurationMutation = {
  __typename?: 'Mutation';
  upsertBuyerInventoryConfiguration?: {
    __typename?: 'BuyerInventoryConfiguration';
    id: string;
    weeksCoveredBeforeMonitor: number;
    weeksCoveredBeforeUrgent: number;
    targetWeeksCovered: number;
    usageRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    location: { __typename?: 'Location'; id: string; name: string };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: { __typename?: 'PlatformProduct'; name: string };
    };
  } | null;
};

export type BuyerInventoryQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type BuyerInventoryQuery = {
  __typename?: 'Query';
  buyerInventory: {
    __typename?: 'PagedInventory';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'Inventory';
      id: string;
      inboundStock: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      location: {
        __typename?: 'Location';
        id: string;
        name: string;
        city: string;
        region: string;
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
          name: string;
          properties?: {
            __typename?: 'ProductProperties';
            species?: {
              __typename?: 'ProductProperty';
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
        };
        length: { __typename?: 'Length'; displayValue: string };
      };
      buyerInventoryConfiguration?: {
        __typename?: 'BuyerInventoryConfiguration';
        id: string;
        weeksCoveredBeforeUrgent: number;
        weeksCoveredBeforeMonitor: number;
        targetWeeksCovered: number;
        usageRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
    } | null>;
  };
};

export type BuyerInventoryForLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type BuyerInventoryForLocationQuery = {
  __typename?: 'Query';
  buyerInventoryForLocation: {
    __typename?: 'PagedInventory';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'Inventory';
      id: string;
      inboundStock: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      location: {
        __typename?: 'Location';
        id: string;
        name: string;
        city: string;
        region: string;
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          code?: string | null;
          name: string;
          properties?: {
            __typename?: 'ProductProperties';
            species?: {
              __typename?: 'ProductProperty';
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
        };
        length: { __typename?: 'Length'; displayValue: string };
      };
      buyerInventoryConfiguration?: {
        __typename?: 'BuyerInventoryConfiguration';
        id: string;
        weeksCoveredBeforeUrgent: number;
        weeksCoveredBeforeMonitor: number;
        targetWeeksCovered: number;
        usageRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      } | null;
    } | null>;
  };
};

export type UpsertInventoryMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  quantity: QuantityInput;
}>;

export type UpsertInventoryMutation = {
  __typename?: 'Mutation';
  upsertInventory?: {
    __typename?: 'Inventory';
    id: string;
    location: { __typename?: 'Location'; id: string; name: string };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: { __typename?: 'PlatformProduct'; name: string };
    };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      weeksCoveredBeforeMonitor: number;
      weeksCoveredBeforeUrgent: number;
      targetWeeksCovered: number;
      location: { __typename?: 'Location'; id: string };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
      };
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
};

export type PlatformProductsLengthsForProductQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type PlatformProductsLengthsForProductQuery = {
  __typename?: 'Query';
  platformProductsLengthsForProduct?: Array<{
    __typename?: 'PlatformProductLength';
    id: string;
    platformProduct: {
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
    };
    length: { __typename?: 'Length'; id: string; displayValue: string };
  }> | null;
};

export type SellerProductInventoriesForBuyerQueryVariables = Exact<{
  platformProductLengthId?: InputMaybe<Scalars['ID']['input']>;
  platformProductId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type SellerProductInventoriesForBuyerQuery = {
  __typename?: 'Query';
  sellerProductInventoriesForBuyer?: Array<{
    __typename?: 'SellerProductInventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    organization: { __typename?: 'Organization'; id: string; name: string };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      length: { __typename?: 'Length'; displayValue: string };
      platformProduct: {
        __typename?: 'PlatformProduct';
        name: string;
        code?: string | null;
        id: string;
      };
    };
    sellerProductConfiguration: {
      __typename?: 'SellerProductConfiguration';
      id: string;
      currencyCode: string;
      pricePerUnit: number;
      readyToShipDays: number;
      minimumOrderQuantity: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    };
  } | null> | null;
};

export type BuyerProductInventoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type BuyerProductInventoryQuery = {
  __typename?: 'Query';
  buyerProductInventory: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    location: {
      __typename?: 'Location';
      id: string;
      name: string;
      city: string;
      region: string;
    };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        code?: string | null;
        actualThicknessInches?: number | null;
        actualWidthInches?: number | null;
        finishCode?: string | null;
        constructionCode?: string | null;
        properties?: {
          __typename?: 'ProductProperties';
          construction?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          species?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          grade?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          dryness?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          surfacing?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
      };
      length: { __typename?: 'Length'; displayValue: string };
    };
    buyerInventoryConfiguration?: {
      __typename?: 'BuyerInventoryConfiguration';
      id: string;
      weeksCoveredBeforeUrgent: number;
      weeksCoveredBeforeMonitor: number;
      targetWeeksCovered: number;
      usageRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    } | null;
  };
};

export type LocationsQueryVariables = Exact<{ [key: string]: never }>;

export type LocationsQuery = {
  __typename?: 'Query';
  locations?: Array<{
    __typename?: 'Location';
    id: string;
    name: string;
  }> | null;
};

export type SellerProductInventoriesQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<SellerProductFiltersInput>;
}>;

export type SellerProductInventoriesQuery = {
  __typename?: 'Query';
  sellerProductInventories: {
    __typename?: 'PaginatedSellerProductInventory';
    paging: {
      __typename?: 'Paging';
      totalPages: number;
      totalElements: number;
      size: number;
      number: number;
    };
    content: Array<{
      __typename?: 'SellerProductInventory';
      id: string;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      sellerProductConfiguration: {
        __typename?: 'SellerProductConfiguration';
        id: string;
        currencyCode: string;
        internalNotes?: string | null;
        readyToShipDays: number;
        pricePerUnit: number;
        status?: SellerProductStatus | null;
        unit: UnitCode;
        criticalStockLevel: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        lowStockLevel: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        replenishmentRatePerWeek: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        minimumOrderQuantity: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
      };
      platformProductsLength: {
        __typename?: 'PlatformProductLength';
        id: string;
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          code?: string | null;
        };
      };
    } | null>;
  };
};

export type GetProductLengthsByProductIdQueryVariables = Exact<{
  inventoryId: Scalars['ID']['input'];
}>;

export type GetProductLengthsByProductIdQuery = {
  __typename?: 'Query';
  sellerProductInventory?: {
    __typename?: 'SellerProductInventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    platformProductsLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      latestPriceMid?: number | null;
      length: {
        __typename?: 'Length';
        id: string;
        displayValue: string;
        actualLengthInches: number;
        nominalLengthInches?: number | null;
      };
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        materialCode?: string | null;
        constructionCode?: string | null;
        code?: string | null;
        properties?: {
          __typename?: 'ProductProperties';
          construction?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          dryness?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          grade?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          species?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          surfacing?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          treatment?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
      };
    };
    sellerProductConfiguration: {
      __typename?: 'SellerProductConfiguration';
      id: string;
      currencyCode: string;
      internalNotes?: string | null;
      pricePerUnit: number;
      readyToShipDays: number;
      status?: SellerProductStatus | null;
      unit: UnitCode;
      replenishmentRatePerWeek: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      criticalStockLevel: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
      lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      minimumOrderQuantity: {
        __typename?: 'Quantity';
        value: number;
        unit: UnitCode;
      };
    };
  } | null;
};

export type UpsertSellerInventoryMutationVariables = Exact<{
  platformProductsLengthId: Scalars['ID']['input'];
  quantity: QuantityInput;
}>;

export type UpsertSellerInventoryMutation = {
  __typename?: 'Mutation';
  upsertSellerInventory?: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
};

export type UpsertSellerProductConfigurationMutationVariables = Exact<{
  platformProductLengthId: Scalars['ID']['input'];
  sellerProductConfigurationInput: SellerProductConfigurationInput;
}>;

export type UpsertSellerProductConfigurationMutation = {
  __typename?: 'Mutation';
  upsertSellerProductConfiguration?: {
    __typename?: 'SellerProductConfiguration';
    id: string;
    currencyCode: string;
    internalNotes?: string | null;
    pricePerUnit: number;
    readyToShipDays: number;
    status?: SellerProductStatus | null;
    criticalStockLevel: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    minimumOrderQuantity: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    replenishmentRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
  } | null;
};

export type UpsertSellerInventoryAndProductConfigurationMutationVariables =
  Exact<{
    platformProductsLengthId: Scalars['ID']['input'];
    quantity: QuantityInput;
    sellerProductConfigurationInput: SellerProductConfigurationInput;
  }>;

export type UpsertSellerInventoryAndProductConfigurationMutation = {
  __typename?: 'Mutation';
  upsertSellerInventory?: {
    __typename?: 'Inventory';
    id: string;
    quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
  } | null;
  upsertSellerProductConfiguration?: {
    __typename?: 'SellerProductConfiguration';
    id: string;
    currencyCode: string;
    internalNotes?: string | null;
    pricePerUnit: number;
    readyToShipDays: number;
    status?: SellerProductStatus | null;
    criticalStockLevel: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    lowStockLevel: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    minimumOrderQuantity: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    replenishmentRatePerWeek: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
  } | null;
};

export type MyProductFilterOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyProductFilterOptionsQuery = {
  __typename?: 'Query';
  lumberSpecies: Array<{
    __typename?: 'LumberSpecies';
    code: string;
    name: string;
  }>;
  lumberGrades: Array<{
    __typename?: 'LumberGrade';
    code: string;
    name: string;
  }>;
  platformProductDimensions: Array<{
    __typename?: 'ProductDimension';
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
  }>;
};

export type ReceiveOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ReceiveOrderMutation = {
  __typename?: 'Mutation';
  receiveOrder?: { __typename?: 'Order'; id: string } | null;
};

export type GetOrderCountsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrderCountsQuery = {
  __typename?: 'Query';
  ordersCount: {
    __typename?: 'OrderStatusCount';
    confirmed: number;
    delivered: number;
    draft: number;
    pendingSellerConfirmation: number;
    shipped: number;
  };
};

export type ShipOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  shippedDate: Scalars['Instant']['input'];
  deliveryStartDate: Scalars['Instant']['input'];
  deliveryEndDate?: InputMaybe<Scalars['Instant']['input']>;
}>;

export type ShipOrderMutation = {
  __typename?: 'Mutation';
  shipOrder?: { __typename?: 'Order'; id: string } | null;
};

export type GetOrderByIdQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type GetOrderByIdQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    createdAt: string;
    status: string;
    shippedDate?: string | null;
    deliveryStartDate?: string | null;
    deliveryEndDate?: string | null;
    receivedDate?: string | null;
    buyer: { __typename?: 'User'; firstName: string; lastName: string };
    shippingLocation: {
      __typename?: 'Location';
      name: string;
      addressLine1: string;
      addressLine2?: string | null;
      city: string;
      region: string;
      zipCode: string;
      organization: { __typename?: 'Organization'; name: string };
    };
    sellingOrganization: { __typename?: 'Organization'; name: string };
    items: Array<{
      __typename?: 'OrderItem';
      price: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          actualWidthInches?: number | null;
          actualThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          nominalThicknessInches?: number | null;
          properties?: {
            __typename?: 'ProductProperties';
            grade?: {
              __typename?: 'ProductProperty';
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
        };
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
    }>;
  } | null;
};

export type GetOrdersQueryVariables = Exact<{
  status?: InputMaybe<OrderStatus>;
}>;

export type GetOrdersQuery = {
  __typename?: 'Query';
  orders?: Array<{
    __typename?: 'Order';
    createdAt: string;
    id: string;
    status: string;
    buyingOrganization: { __typename?: 'Organization'; name: string };
    sellingOrganization: { __typename?: 'Organization'; name: string };
    items: Array<{
      __typename?: 'OrderItem';
      price: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    }>;
  }> | null;
};

export type ConfirmOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;

export type ConfirmOrderMutation = {
  __typename?: 'Mutation';
  confirmOrder?: { __typename?: 'Order'; id: string } | null;
};

export type PlaceOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
}>;

export type PlaceOrderMutation = {
  __typename?: 'Mutation';
  placeOrder?: { __typename?: 'Order'; id: string } | null;
};

export type PlatformProductsQueryVariables = Exact<{ [key: string]: never }>;

export type PlatformProductsQuery = {
  __typename?: 'Query';
  platformProducts?: Array<{
    __typename?: 'PlatformProduct';
    id: string;
    name: string;
  }> | null;
};

export type PlatformProductByIdQueryVariables = Exact<{
  platformProductId: Scalars['ID']['input'];
}>;

export type PlatformProductByIdQuery = {
  __typename?: 'Query';
  platformProduct?: {
    __typename?: 'PlatformProduct';
    actualLengthInches?: number | null;
    actualThicknessInches?: number | null;
    actualWidthInches?: number | null;
    code?: string | null;
    constructionCode?: string | null;
    finishCode?: string | null;
    harmonizedCode?: string | null;
    id: string;
    isNominal?: boolean | null;
    materialCode?: string | null;
    name: string;
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
    standardUnitsCode?: UnitCode | null;
    lengths?: Array<{
      __typename?: 'Length';
      actualLengthInches: number;
      nominalLengthInches?: number | null;
      displayValue: string;
      id: string;
    } | null> | null;
    properties?: {
      __typename?: 'ProductProperties';
      construction?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
      dryness?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
      grade?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
      species?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
      surfacing?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
      treatment?: {
        __typename?: 'ProductProperty';
        code?: string | null;
        name?: string | null;
      } | null;
    } | null;
    piecesPerBundle: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    unitsPerContainer: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    unitsPerRailCar: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    unitsPerTruckload: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
  } | null;
};

export type AllUniqueProductsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
  filters?: InputMaybe<UniqueProductFiltersInput>;
}>;

export type AllUniqueProductsQuery = {
  __typename?: 'Query';
  findAvailableUniqueProductsWithSellers: {
    __typename?: 'PagedUniqueProductWithSellers';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'UniqueProductWithSellers';
      id: string;
      leadTimeMax: number;
      leadTimeMin: number;
      listingsCount: number;
      priceMax: number;
      priceMin: number;
      sellersCount: number;
      lengths?: Array<{
        __typename?: 'Length';
        actualLengthInches: number;
        nominalLengthInches?: number | null;
        displayValue: string;
        id: string;
      } | null> | null;
      totalStock: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      platformProduct: {
        __typename?: 'PlatformProduct';
        id: string;
        name: string;
        finishCode?: string | null;
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        unitsPerContainer: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        unitsPerRailCar: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        unitsPerTruckload: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        properties?: {
          __typename?: 'ProductProperties';
          species?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          grade?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
      };
    } | null>;
  };
};

export type UpdateCartMutationVariables = Exact<{
  sellingOrganizationId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  quantity: QuantityInput;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateCartMutation = {
  __typename?: 'Mutation';
  updateCart?: {
    __typename?: 'Cart';
    id: string;
    items?: Array<{
      __typename?: 'OrderItem';
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    }> | null;
  } | null;
};

export type GetCartsWithFilterQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetCartsWithFilterQuery = {
  __typename?: 'Query';
  carts?: Array<{
    __typename?: 'Cart';
    id: string;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
    items?: Array<{
      __typename?: 'OrderItem';
      price: number;
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          isNominal?: boolean | null;
          nominalThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          actualThicknessInches?: number | null;
          actualWidthInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode?: UnitCode | null;
          unitsPerTruckload: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
          unitsPerRailCar: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
          properties?: {
            __typename?: 'ProductProperties';
            grade?: {
              __typename?: 'ProductProperty';
              code?: string | null;
              name?: string | null;
            } | null;
          } | null;
        };
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
    }> | null;
    shippingLocation?: {
      __typename?: 'Location';
      id: string;
      name: string;
      region: string;
      zipCode: string;
      country: string;
      city: string;
      addressLine2?: string | null;
      addressLine1: string;
    } | null;
  }> | null;
};

export type GetCartQueryVariables = Exact<{
  cartId: Scalars['ID']['input'];
}>;

export type GetCartQuery = {
  __typename?: 'Query';
  cart?: {
    __typename?: 'Cart';
    id: string;
    sellingOrganization: {
      __typename?: 'Organization';
      id: string;
      name: string;
    };
    items?: Array<{
      __typename?: 'OrderItem';
      price: number;
      quantity: { __typename?: 'Quantity'; value: number; unit: UnitCode };
      platformProductsLengths: {
        __typename?: 'PlatformProductLength';
        id: string;
        platformProduct: {
          __typename?: 'PlatformProduct';
          id: string;
          name: string;
          isNominal?: boolean | null;
          nominalThicknessInches?: number | null;
          nominalWidthInches?: number | null;
          actualThicknessInches?: number | null;
          actualWidthInches?: number | null;
          actualLengthInches?: number | null;
          standardUnitsCode?: UnitCode | null;
          unitsPerTruckload: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
          unitsPerRailCar: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
          piecesPerBundle: {
            __typename?: 'Quantity';
            value: number;
            unit: UnitCode;
          };
        };
        length: {
          __typename?: 'Length';
          id: string;
          displayValue: string;
          actualLengthInches: number;
          nominalLengthInches?: number | null;
        };
      };
    }> | null;
  } | null;
};

export type AvailableProductsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
}>;

export type AvailableProductsQuery = {
  __typename?: 'Query';
  availableProducts: {
    __typename?: 'PagedSellerProductConfiguration';
    paging: {
      __typename?: 'Paging';
      totalElements: number;
      totalPages: number;
      number: number;
      size: number;
    };
    content: Array<{
      __typename?: 'SellerProductConfiguration';
      id: string;
      pricePerUnit: number;
      organization: { __typename?: 'Organization'; name: string };
      platformProductLength: {
        __typename?: 'PlatformProductLength';
        platformProduct: {
          __typename?: 'PlatformProduct';
          name: string;
          properties?: {
            __typename?: 'ProductProperties';
            species?: {
              __typename?: 'ProductProperty';
              code?: string | null;
            } | null;
            grade?: {
              __typename?: 'ProductProperty';
              code?: string | null;
            } | null;
          } | null;
        };
        length: { __typename?: 'Length'; displayValue: string };
      };
    } | null>;
  };
};

export type ProductFilterOptionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ProductFilterOptionsQuery = {
  __typename?: 'Query';
  lumberSpecies: Array<{
    __typename?: 'LumberSpecies';
    code: string;
    name: string;
  }>;
  lumberGrades: Array<{
    __typename?: 'LumberGrade';
    code: string;
    name: string;
  }>;
  platformProductDimensions: Array<{
    __typename?: 'ProductDimension';
    nominalThicknessInches?: number | null;
    nominalWidthInches?: number | null;
  }>;
  allUniqueProductInventoryLocationsForBuyer: Array<{
    __typename?: 'Location';
    id: string;
    name: string;
    addressLine1: string;
    addressLine2?: string | null;
    city: string;
    region: string;
    zipCode: string;
    country: string;
  }>;
};

export type SellerProductQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SellerProductQuery = {
  __typename?: 'Query';
  sellerProduct?: {
    __typename?: 'SellerProductConfiguration';
    id: string;
    pricePerUnit: number;
    readyToShipDays: number;
    unit: UnitCode;
    minimumOrderQuantity: {
      __typename?: 'Quantity';
      value: number;
      unit: UnitCode;
    };
    organization: { __typename?: 'Organization'; id: string; name: string };
    platformProductLength: {
      __typename?: 'PlatformProductLength';
      id: string;
      platformProduct: {
        __typename?: 'PlatformProduct';
        name: string;
        code?: string | null;
        isNominal?: boolean | null;
        actualThicknessInches?: number | null;
        actualWidthInches?: number | null;
        actualLengthInches?: number | null;
        nominalThicknessInches?: number | null;
        nominalWidthInches?: number | null;
        finishCode?: string | null;
        standardUnitsCode?: UnitCode | null;
        unitsPerContainer: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        unitsPerRailCar: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        unitsPerTruckload: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        piecesPerBundle: {
          __typename?: 'Quantity';
          value: number;
          unit: UnitCode;
        };
        properties?: {
          __typename?: 'ProductProperties';
          species?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          grade?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          dryness?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          surfacing?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          treatment?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
          construction?: {
            __typename?: 'ProductProperty';
            code?: string | null;
            name?: string | null;
          } | null;
        } | null;
      };
      length: {
        __typename?: 'Length';
        displayValue: string;
        actualLengthInches: number;
        nominalLengthInches?: number | null;
      };
    };
  } | null;
};

export type SellerInventoryProductLengthsByPlatformProductQueryVariables =
  Exact<{
    platformProductId: Scalars['ID']['input'];
  }>;

export type SellerInventoryProductLengthsByPlatformProductQuery = {
  __typename?: 'Query';
  sellerInventoryProductLengthsByPlatformProduct?: Array<{
    __typename?: 'PlatformProductLength';
    id: string;
    latestPriceMax?: number | null;
    latestPriceMin?: number | null;
    latestPriceMid?: number | null;
    length: {
      __typename?: 'Length';
      actualLengthInches: number;
      nominalLengthInches?: number | null;
      displayValue: string;
    };
    platformProduct: {
      __typename?: 'PlatformProduct';
      id: string;
      name: string;
    };
  }> | null;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<
    DocumentTypeDecoration<TResult, TVariables>['__apiType']
  >;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const CurrentUserDocument = new TypedDocumentString(`
    query currentUser {
  currentUser {
    externalId
    firstName
    id
    lastName
    role
    organization {
      id
      name
    }
    companies {
      code
      id
      name
      organization {
        id
        name
      }
      locations {
        addressLine1
        city
        country
        id
        name
        region
        zipCode
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  CurrentUserQuery,
  CurrentUserQueryVariables
>;
export const UpsertBuyerInventoryConfigurationDocument =
  new TypedDocumentString(`
    mutation upsertBuyerInventoryConfiguration($platformProductsLengthId: ID!, $locationId: ID!, $usageRatePerWeek: QuantityInput!, $weeksCoveredBeforeMonitor: Float, $weeksCoveredBeforeUrgent: Float, $targetWeeksCovered: Float) {
  upsertBuyerInventoryConfiguration(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    usageRatePerWeek: $usageRatePerWeek
    weeksCoveredBeforeMonitor: $weeksCoveredBeforeMonitor
    weeksCoveredBeforeUrgent: $weeksCoveredBeforeUrgent
    targetWeeksCovered: $targetWeeksCovered
  ) {
    id
    usageRatePerWeek {
      value
      unit
    }
    weeksCoveredBeforeMonitor
    weeksCoveredBeforeUrgent
    targetWeeksCovered
    location {
      id
      name
    }
    platformProductsLength {
      id
      platformProduct {
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    UpsertBuyerInventoryConfigurationMutation,
    UpsertBuyerInventoryConfigurationMutationVariables
  >;
export const BuyerInventoryDocument = new TypedDocumentString(`
    query buyerInventory($page: Int!, $size: Int!) {
  buyerInventory(pageInput: {page: $page, size: $size}) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      quantity {
        value
        unit
      }
      inboundStock
      location {
        id
        name
        city
        region
      }
      platformProductsLength {
        id
        platformProduct {
          id
          code
          name
          properties {
            species {
              code
              name
            }
          }
        }
        length {
          displayValue
        }
      }
      buyerInventoryConfiguration {
        id
        usageRatePerWeek {
          value
          unit
        }
        weeksCoveredBeforeUrgent
        weeksCoveredBeforeMonitor
        targetWeeksCovered
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryQuery,
  BuyerInventoryQueryVariables
>;
export const BuyerInventoryForLocationDocument = new TypedDocumentString(`
    query buyerInventoryForLocation($locationId: ID!, $page: Int!, $size: Int!) {
  buyerInventoryForLocation(
    locationId: $locationId
    pageInput: {page: $page, size: $size}
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      quantity {
        value
        unit
      }
      inboundStock
      location {
        id
        name
        city
        region
      }
      platformProductsLength {
        id
        platformProduct {
          id
          code
          name
          properties {
            species {
              code
              name
            }
          }
        }
        length {
          displayValue
        }
      }
      buyerInventoryConfiguration {
        id
        usageRatePerWeek {
          value
          unit
        }
        weeksCoveredBeforeUrgent
        weeksCoveredBeforeMonitor
        targetWeeksCovered
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerInventoryForLocationQuery,
  BuyerInventoryForLocationQueryVariables
>;
export const UpsertInventoryDocument = new TypedDocumentString(`
    mutation upsertInventory($platformProductsLengthId: ID!, $locationId: ID!, $quantity: QuantityInput!) {
  upsertInventory(
    platformProductsLengthId: $platformProductsLengthId
    locationId: $locationId
    quantity: $quantity
  ) {
    id
    location {
      id
      name
    }
    platformProductsLength {
      id
      platformProduct {
        name
      }
    }
    buyerInventoryConfiguration {
      weeksCoveredBeforeMonitor
      weeksCoveredBeforeUrgent
      targetWeeksCovered
      location {
        id
      }
      platformProductsLength {
        id
      }
      usageRatePerWeek {
        value
        unit
      }
    }
    quantity {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertInventoryMutation,
  UpsertInventoryMutationVariables
>;
export const PlatformProductsLengthsForProductDocument =
  new TypedDocumentString(`
    query platformProductsLengthsForProduct($platformProductId: ID!) {
  platformProductsLengthsForProduct(platformProductId: $platformProductId) {
    id
    platformProduct {
      id
      name
    }
    length {
      id
      displayValue
    }
  }
}
    `) as unknown as TypedDocumentString<
    PlatformProductsLengthsForProductQuery,
    PlatformProductsLengthsForProductQueryVariables
  >;
export const SellerProductInventoriesForBuyerDocument =
  new TypedDocumentString(`
    query sellerProductInventoriesForBuyer($platformProductLengthId: ID, $platformProductId: ID) {
  sellerProductInventoriesForBuyer(
    filter: {platformProductLengthId: $platformProductLengthId, platformProductId: $platformProductId}
  ) {
    id
    quantity {
      value
      unit
    }
    organization {
      id
      name
    }
    platformProductsLength {
      length {
        displayValue
      }
      platformProduct {
        name
        code
        id
      }
      id
    }
    sellerProductConfiguration {
      id
      currencyCode
      pricePerUnit
      minimumOrderQuantity {
        value
        unit
      }
      readyToShipDays
    }
  }
}
    `) as unknown as TypedDocumentString<
    SellerProductInventoriesForBuyerQuery,
    SellerProductInventoriesForBuyerQueryVariables
  >;
export const BuyerProductInventoryDocument = new TypedDocumentString(`
    query buyerProductInventory($id: ID!) {
  buyerProductInventory(id: $id) {
    id
    quantity {
      value
      unit
    }
    location {
      id
      name
      city
      region
    }
    platformProductsLength {
      id
      platformProduct {
        id
        name
        code
        actualThicknessInches
        actualWidthInches
        finishCode
        constructionCode
        properties {
          construction {
            code
            name
          }
          species {
            code
            name
          }
          grade {
            code
            name
          }
          dryness {
            code
            name
          }
          surfacing {
            code
            name
          }
        }
      }
      length {
        displayValue
      }
    }
    buyerInventoryConfiguration {
      id
      usageRatePerWeek {
        value
        unit
      }
      weeksCoveredBeforeUrgent
      weeksCoveredBeforeMonitor
      targetWeeksCovered
    }
  }
}
    `) as unknown as TypedDocumentString<
  BuyerProductInventoryQuery,
  BuyerProductInventoryQueryVariables
>;
export const LocationsDocument = new TypedDocumentString(`
    query locations {
  locations {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<
  LocationsQuery,
  LocationsQueryVariables
>;
export const SellerProductInventoriesDocument = new TypedDocumentString(`
    query sellerProductInventories($page: Int!, $size: Int!, $filters: SellerProductFiltersInput) {
  sellerProductInventories(
    pageInput: {page: $page, size: $size}
    filters: $filters
  ) {
    paging {
      totalPages
      totalElements
      size
      number
    }
    content {
      id
      quantity {
        value
        unit
      }
      sellerProductConfiguration {
        id
        criticalStockLevel {
          value
          unit
        }
        currencyCode
        internalNotes
        lowStockLevel {
          value
          unit
        }
        readyToShipDays
        replenishmentRatePerWeek {
          value
          unit
        }
        pricePerUnit
        minimumOrderQuantity {
          value
          unit
        }
        status
        unit
      }
      platformProductsLength {
        id
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
        platformProduct {
          id
          name
          code
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerProductInventoriesQuery,
  SellerProductInventoriesQueryVariables
>;
export const GetProductLengthsByProductIdDocument = new TypedDocumentString(`
    query GetProductLengthsByProductId($inventoryId: ID!) {
  sellerProductInventory(id: $inventoryId) {
    id
    quantity {
      value
      unit
    }
    platformProductsLength {
      id
      length {
        id
        displayValue
        actualLengthInches
        nominalLengthInches
      }
      latestPriceMid
      platformProduct {
        id
        name
        materialCode
        constructionCode
        code
        properties {
          construction {
            code
            name
          }
          dryness {
            code
            name
          }
          grade {
            code
            name
          }
          species {
            code
            name
          }
          surfacing {
            code
            name
          }
          treatment {
            code
            name
          }
        }
      }
    }
    sellerProductConfiguration {
      id
      currencyCode
      internalNotes
      pricePerUnit
      replenishmentRatePerWeek {
        value
        unit
      }
      readyToShipDays
      criticalStockLevel {
        value
        unit
      }
      lowStockLevel {
        value
        unit
      }
      minimumOrderQuantity {
        value
        unit
      }
      status
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetProductLengthsByProductIdQuery,
  GetProductLengthsByProductIdQueryVariables
>;
export const UpsertSellerInventoryDocument = new TypedDocumentString(`
    mutation UpsertSellerInventory($platformProductsLengthId: ID!, $quantity: QuantityInput!) {
  upsertSellerInventory(
    platformProductsLengthId: $platformProductsLengthId
    quantity: $quantity
  ) {
    id
    quantity {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpsertSellerInventoryMutation,
  UpsertSellerInventoryMutationVariables
>;
export const UpsertSellerProductConfigurationDocument =
  new TypedDocumentString(`
    mutation UpsertSellerProductConfiguration($platformProductLengthId: ID!, $sellerProductConfigurationInput: SellerProductConfigurationInput!) {
  upsertSellerProductConfiguration(
    platformProductLengthId: $platformProductLengthId
    sellerProductConfigurationInput: $sellerProductConfigurationInput
  ) {
    id
    criticalStockLevel {
      value
      unit
    }
    currencyCode
    internalNotes
    lowStockLevel {
      value
      unit
    }
    minimumOrderQuantity {
      value
      unit
    }
    pricePerUnit
    readyToShipDays
    replenishmentRatePerWeek {
      value
      unit
    }
    status
  }
}
    `) as unknown as TypedDocumentString<
    UpsertSellerProductConfigurationMutation,
    UpsertSellerProductConfigurationMutationVariables
  >;
export const UpsertSellerInventoryAndProductConfigurationDocument =
  new TypedDocumentString(`
    mutation UpsertSellerInventoryAndProductConfiguration($platformProductsLengthId: ID!, $quantity: QuantityInput!, $sellerProductConfigurationInput: SellerProductConfigurationInput!) {
  upsertSellerInventory(
    platformProductsLengthId: $platformProductsLengthId
    quantity: $quantity
  ) {
    id
    quantity {
      value
      unit
    }
  }
  upsertSellerProductConfiguration(
    platformProductLengthId: $platformProductsLengthId
    sellerProductConfigurationInput: $sellerProductConfigurationInput
  ) {
    id
    criticalStockLevel {
      value
      unit
    }
    currencyCode
    internalNotes
    lowStockLevel {
      value
      unit
    }
    minimumOrderQuantity {
      value
      unit
    }
    pricePerUnit
    readyToShipDays
    replenishmentRatePerWeek {
      value
      unit
    }
    status
  }
}
    `) as unknown as TypedDocumentString<
    UpsertSellerInventoryAndProductConfigurationMutation,
    UpsertSellerInventoryAndProductConfigurationMutationVariables
  >;
export const MyProductFilterOptionsDocument = new TypedDocumentString(`
    query MyProductFilterOptions {
  lumberSpecies {
    code
    name
  }
  lumberGrades {
    code
    name
  }
  platformProductDimensions {
    nominalThicknessInches
    nominalWidthInches
  }
}
    `) as unknown as TypedDocumentString<
  MyProductFilterOptionsQuery,
  MyProductFilterOptionsQueryVariables
>;
export const ReceiveOrderDocument = new TypedDocumentString(`
    mutation receiveOrder($orderId: ID!) {
  receiveOrder(id: $orderId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ReceiveOrderMutation,
  ReceiveOrderMutationVariables
>;
export const GetOrderCountsDocument = new TypedDocumentString(`
    query getOrderCounts {
  ordersCount {
    confirmed
    delivered
    draft
    pendingSellerConfirmation
    shipped
  }
}
    `) as unknown as TypedDocumentString<
  GetOrderCountsQuery,
  GetOrderCountsQueryVariables
>;
export const ShipOrderDocument = new TypedDocumentString(`
    mutation ShipOrder($orderId: ID!, $shippedDate: Instant!, $deliveryStartDate: Instant!, $deliveryEndDate: Instant) {
  shipOrder(
    id: $orderId
    shippedDate: $shippedDate
    deliveryStartDate: $deliveryStartDate
    deliveryEndDate: $deliveryEndDate
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ShipOrderMutation,
  ShipOrderMutationVariables
>;
export const GetOrderByIdDocument = new TypedDocumentString(`
    query GetOrderById($orderId: ID!) {
  order(id: $orderId) {
    id
    createdAt
    status
    shippedDate
    deliveryStartDate
    deliveryEndDate
    receivedDate
    buyer {
      firstName
      lastName
    }
    shippingLocation {
      name
      addressLine1
      addressLine2
      city
      region
      zipCode
      organization {
        name
      }
    }
    sellingOrganization {
      name
    }
    items {
      quantity {
        value
        unit
      }
      price
      platformProductsLengths {
        id
        platformProduct {
          id
          name
          actualWidthInches
          actualThicknessInches
          nominalWidthInches
          nominalThicknessInches
          properties {
            grade {
              code
              name
            }
          }
        }
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetOrderByIdQuery,
  GetOrderByIdQueryVariables
>;
export const GetOrdersDocument = new TypedDocumentString(`
    query getOrders($status: OrderStatus) {
  orders(status: $status) {
    createdAt
    id
    buyingOrganization {
      name
    }
    sellingOrganization {
      name
    }
    items {
      quantity {
        value
        unit
      }
      price
    }
    status
  }
}
    `) as unknown as TypedDocumentString<
  GetOrdersQuery,
  GetOrdersQueryVariables
>;
export const ConfirmOrderDocument = new TypedDocumentString(`
    mutation confirmOrder($orderId: ID!) {
  confirmOrder(id: $orderId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  ConfirmOrderMutation,
  ConfirmOrderMutationVariables
>;
export const PlaceOrderDocument = new TypedDocumentString(`
    mutation placeOrder($orderId: ID!, $locationId: ID!) {
  placeOrder(orderId: $orderId, locationId: $locationId) {
    id
  }
}
    `) as unknown as TypedDocumentString<
  PlaceOrderMutation,
  PlaceOrderMutationVariables
>;
export const PlatformProductsDocument = new TypedDocumentString(`
    query platformProducts {
  platformProducts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<
  PlatformProductsQuery,
  PlatformProductsQueryVariables
>;
export const PlatformProductByIdDocument = new TypedDocumentString(`
    query platformProductById($platformProductId: ID!) {
  platformProduct(id: $platformProductId) {
    actualLengthInches
    actualThicknessInches
    actualWidthInches
    code
    constructionCode
    finishCode
    harmonizedCode
    id
    isNominal
    lengths {
      actualLengthInches
      nominalLengthInches
      displayValue
      id
    }
    materialCode
    name
    nominalThicknessInches
    nominalWidthInches
    properties {
      construction {
        code
        name
      }
      dryness {
        code
        name
      }
      grade {
        code
        name
      }
      species {
        code
        name
      }
      surfacing {
        code
        name
      }
      treatment {
        code
        name
      }
    }
    piecesPerBundle {
      value
      unit
    }
    standardUnitsCode
    unitsPerContainer {
      value
      unit
    }
    unitsPerRailCar {
      value
      unit
    }
    unitsPerTruckload {
      value
      unit
    }
  }
}
    `) as unknown as TypedDocumentString<
  PlatformProductByIdQuery,
  PlatformProductByIdQueryVariables
>;
export const AllUniqueProductsDocument = new TypedDocumentString(`
    query AllUniqueProducts($page: Int!, $size: Int!, $filters: UniqueProductFiltersInput) {
  findAvailableUniqueProductsWithSellers(
    pageInput: {page: $page, size: $size}
    filters: $filters
  ) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      leadTimeMax
      leadTimeMin
      lengths {
        actualLengthInches
        nominalLengthInches
        displayValue
        id
      }
      listingsCount
      priceMax
      priceMin
      sellersCount
      totalStock {
        value
        unit
      }
      platformProduct {
        id
        name
        finishCode
        piecesPerBundle {
          value
          unit
        }
        unitsPerContainer {
          value
          unit
        }
        unitsPerRailCar {
          value
          unit
        }
        unitsPerTruckload {
          value
          unit
        }
        properties {
          species {
            code
            name
          }
          grade {
            code
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  AllUniqueProductsQuery,
  AllUniqueProductsQueryVariables
>;
export const UpdateCartDocument = new TypedDocumentString(`
    mutation updateCart($sellingOrganizationId: ID!, $productId: ID!, $quantity: QuantityInput!, $locationId: ID) {
  updateCart(
    sellingOrganizationId: $sellingOrganizationId
    productId: $productId
    quantity: $quantity
    locationId: $locationId
  ) {
    id
    items {
      quantity {
        value
        unit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  UpdateCartMutation,
  UpdateCartMutationVariables
>;
export const GetCartsWithFilterDocument = new TypedDocumentString(`
    query GetCartsWithFilter($locationId: ID) {
  carts(filter: {locationId: $locationId}) {
    id
    sellingOrganization {
      id
      name
    }
    items {
      platformProductsLengths {
        id
        platformProduct {
          id
          name
          isNominal
          nominalThicknessInches
          nominalWidthInches
          actualThicknessInches
          actualWidthInches
          actualLengthInches
          standardUnitsCode
          unitsPerTruckload {
            value
            unit
          }
          unitsPerRailCar {
            value
            unit
          }
          piecesPerBundle {
            value
            unit
          }
          properties {
            grade {
              code
              name
            }
          }
        }
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
      }
      price
      quantity {
        value
        unit
      }
    }
    shippingLocation {
      id
      name
      region
      zipCode
      country
      city
      addressLine2
      addressLine1
    }
  }
}
    `) as unknown as TypedDocumentString<
  GetCartsWithFilterQuery,
  GetCartsWithFilterQueryVariables
>;
export const GetCartDocument = new TypedDocumentString(`
    query GetCart($cartId: ID!) {
  cart(id: $cartId) {
    id
    sellingOrganization {
      id
      name
    }
    items {
      price
      quantity {
        value
        unit
      }
      platformProductsLengths {
        id
        platformProduct {
          id
          name
          isNominal
          nominalThicknessInches
          nominalWidthInches
          actualThicknessInches
          actualWidthInches
          actualLengthInches
          standardUnitsCode
          unitsPerTruckload {
            value
            unit
          }
          unitsPerRailCar {
            value
            unit
          }
          piecesPerBundle {
            value
            unit
          }
        }
        length {
          id
          displayValue
          actualLengthInches
          nominalLengthInches
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCartQuery, GetCartQueryVariables>;
export const AvailableProductsDocument = new TypedDocumentString(`
    query AvailableProducts($page: Int!, $size: Int!) {
  availableProducts(pageInput: {page: $page, size: $size}) {
    paging {
      totalElements
      totalPages
      number
      size
    }
    content {
      id
      pricePerUnit
      organization {
        name
      }
      platformProductLength {
        platformProduct {
          name
          properties {
            species {
              code
            }
            grade {
              code
            }
          }
        }
        length {
          displayValue
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  AvailableProductsQuery,
  AvailableProductsQueryVariables
>;
export const ProductFilterOptionsDocument = new TypedDocumentString(`
    query ProductFilterOptions {
  lumberSpecies {
    code
    name
  }
  lumberGrades {
    code
    name
  }
  platformProductDimensions {
    nominalThicknessInches
    nominalWidthInches
  }
  allUniqueProductInventoryLocationsForBuyer {
    id
    name
    addressLine1
    addressLine2
    city
    region
    zipCode
    country
  }
}
    `) as unknown as TypedDocumentString<
  ProductFilterOptionsQuery,
  ProductFilterOptionsQueryVariables
>;
export const SellerProductDocument = new TypedDocumentString(`
    query SellerProduct($id: ID!) {
  sellerProduct(id: $id) {
    id
    pricePerUnit
    minimumOrderQuantity {
      value
      unit
    }
    readyToShipDays
    unit
    organization {
      id
      name
    }
    platformProductLength {
      id
      platformProduct {
        name
        code
        isNominal
        actualThicknessInches
        actualWidthInches
        actualLengthInches
        nominalThicknessInches
        nominalWidthInches
        finishCode
        standardUnitsCode
        unitsPerContainer {
          value
          unit
        }
        unitsPerRailCar {
          value
          unit
        }
        unitsPerTruckload {
          value
          unit
        }
        piecesPerBundle {
          value
          unit
        }
        properties {
          species {
            code
            name
          }
          grade {
            code
            name
          }
          dryness {
            code
            name
          }
          surfacing {
            code
            name
          }
          treatment {
            code
            name
          }
          construction {
            code
            name
          }
        }
      }
      length {
        displayValue
        actualLengthInches
        nominalLengthInches
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  SellerProductQuery,
  SellerProductQueryVariables
>;
export const SellerInventoryProductLengthsByPlatformProductDocument =
  new TypedDocumentString(`
    query sellerInventoryProductLengthsByPlatformProduct($platformProductId: ID!) {
  sellerInventoryProductLengthsByPlatformProduct(
    platformProductId: $platformProductId
  ) {
    id
    length {
      actualLengthInches
      nominalLengthInches
      displayValue
    }
    platformProduct {
      id
      name
    }
    latestPriceMax
    latestPriceMin
    latestPriceMid
  }
}
    `) as unknown as TypedDocumentString<
    SellerInventoryProductLengthsByPlatformProductQuery,
    SellerInventoryProductLengthsByPlatformProductQueryVariables
  >;
